import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable, map } from 'rxjs'
import { Store } from '@ngrx/store'
import { ServiceUrlConstants } from 'src/constants/service-url-constants'
import { AppState } from 'src/store/state/app.state'
import { EmployeeBankingInformationAPIModel } from 'src/models/api.model'
import { getEmployeeBankingInfo } from 'src/store/selector/employee.selector'
import { CLEAR_EMPLOYEE_BANKING_INFO } from 'src/store/action/employee.action'

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  getEmployeeBankingInfoFromStore = (): Observable<EmployeeBankingInformationAPIModel[]> => {
    return this.appState.select(getEmployeeBankingInfo())
  }

  callGetEmployeeBankingInfoApi = employeeId => {
    const url = `${ServiceUrlConstants.API_EMPLOYEE_BANKING_INFO.replace('{0}', employeeId)}`
    return this.webservice.get(url).pipe(map((data: EmployeeBankingInformationAPIModel[]) => data))
  }

  dispatchClearEmployeeBankingInfoFromStore = () => {
    return this.appState.dispatch(CLEAR_EMPLOYEE_BANKING_INFO())
  }
}
